/**
 * GDPR Cookie Consent Banner
 * Shows on first visit, stores preference in localStorage.
 * Only essential cookies (auth session) are used regardless of choice.
 * Non-essential cookies (analytics, tracking) are blocked until consent.
 */

import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './CookieConsent.css';

const CONSENT_KEY = 'cookie_consent';

const CookieConsent = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem(CONSENT_KEY);
    if (!consent) {
      // Small delay so it doesn't compete with page load
      const timer = setTimeout(() => setVisible(true), 1000);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem(CONSENT_KEY, JSON.stringify({
      essential: true,
      analytics: true,
      accepted_at: new Date().toISOString()
    }));
    setVisible(false);
  };

  const handleDecline = () => {
    localStorage.setItem(CONSENT_KEY, JSON.stringify({
      essential: true,
      analytics: false,
      accepted_at: new Date().toISOString()
    }));
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="cookie-consent-banner" role="dialog" aria-label="Cookie consent">
      <div className="cookie-consent-content">
        <div className="cookie-consent-text">
          <strong>Cookie Notice</strong>
          We use essential cookies to keep you signed in and ensure the site works properly.
          We may also use analytics cookies to improve your experience.
          By clicking "Accept All", you consent to all cookies.
          See our <Link to="/privacy">Privacy Policy</Link> for details.
        </div>
        <div className="cookie-consent-actions">
          <button className="cookie-consent-btn decline" onClick={handleDecline}>
            Essential Only
          </button>
          <button className="cookie-consent-btn accept" onClick={handleAccept}>
            Accept All
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
